import { useUpdateHardwareMutation } from '../../api/api-hooks';
import { HardwareItemForm } from './hardwareTypes';

const useHardwareItemUpdater = () => {
  const [editHardware] = useUpdateHardwareMutation();
  return (item: HardwareItemForm, id: number) => {
    if (
      item.serial === null ||
      item.hardwareType === null ||
      item.hardwareType === undefined ||
      item.companies.length === 0
    )
      return { error: { data: { message: 'Missing required fields' } } };
    return editHardware({
      id: id,
      updateHardwareDto: {
        id: id,
        serial: item.serial,
        hardwareTypeId: Number(item.hardwareType.id),
        companies: item.companies,
        firmware: item.firmware,
        notes: item.notes,
        shipper: item.shipper,
        warrantyStartDate: item.warrantyStartDate
          ? item.warrantyStartDate
          : null,
        warrantyEndDate: item.warrantyEndDate ? item.warrantyEndDate : null,
        trackingNumber: item.trackingNumber,
        orderId: item.order ? item.order.id : null,
        manufacturer: item.manufacturer ? item.manufacturer : null,
        departmentId: item.department?.id ? item.department.id : null,
      },
    });
  };
};

export default useHardwareItemUpdater;
